import { createSelector } from "reselect";

// Selectors
import { partnerNameSelector } from "../partner_name_selector";

/**
 * Selector that determines if the patient header is enabled on the patient view
 */
export const patientHeaderEnabledSelector = createSelector(
  partnerNameSelector,
  partnerName => {
    switch (partnerName) {
      case "pcc":
      case "pcc_wound":
        return false;
      default:
        return true;
    }
  }
);
